import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "osm-token-container" }
const _hoisted_2 = { class: "token-setting-btn" }

import { ref } from 'vue'
import { useStore } from 'vuex'
import { getStorage, setStorage } from '@/utils/storage'


export default /*@__PURE__*/_defineComponent({
  __name: 'token-setting',
  emits: ['onSetOmsToken'],
  setup(__props, { emit: __emit }) {

const store = useStore()
const emit = __emit
const omsToken = ref(getStorage<string>('omsToken') || '')
const getUserId = () => {
  try {
    return store.state.persistence.userInfo.userId || ''
  } catch (e) {
    return ''
  }
}


const tableData = ref([
  {
    name: 'userId',
    key: 'userId',
    value: getUserId(),
    isDisabled: true
  },
  {
    name: 'Authorization',
    key: 'Authorization',
    value: getStorage<string>('Authorization') || '',
    isDisabled: true
  },
  {
    name: 'omsToken',
    key: 'omsToken',
    value: getStorage<string>('omsToken') || '',
    isDisabled: false
  }
])

const handleInput = (key: string, val: string) => {
    omsToken.value = val
}
const handleSaveToken = () => {
    if(omsToken.value && omsToken.value.trim().length > 0){
        setStorage('omsToken', omsToken.value)
        emit('onSetOmsToken', omsToken.value)
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      shadow: "never",
      header: "Token 配置"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: tableData.value,
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "参数名称",
              width: "200"
            }),
            _createVNode(_component_el_table_column, { label: "参数值" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_input, {
                  modelValue: row.value,
                  "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                  type: "textarea",
                  autosize: { minRows: 5, maxRows: 5 },
                  rows: 5,
                  disabled: row.isDisabled,
                  placeholder: `请输入 ${row.name}`,
                  clearable: "",
                  onInput: (val) => handleInput(row.key, val)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder", "onInput"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_vkn_button, {
            class: "insert-btn",
            label: "保存设置",
            type: "primary",
            disabled: !omsToken.value,
            "icon-placement": "left",
            size: "small",
            onClick: handleSaveToken
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})